import type { Styles } from 'src/theme/themes';

export const styles = {
  rowLabel: (theme) => ({
    gap: 0.5,
    width: theme.spacing(23),
  }),
  barContainer: {
    flexGrow: 1,
  },
  bar: {
    borderRightWidth: '2px',
    borderRightStyle: 'solid',
    height: '100%',
    transition: 'all 0.5s ease-out',
  },
  barLabel: {
    marginLeft: '-2px',
  },
  barLabelCircle: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid',
  },
} satisfies Styles;
